export default [
  {
    path: '/user-management/user',
    name: 'user-management-user',
    component: () => import('../../views/user_management/user'),
    meta: {
      title: 'User Management',
      activeMenu: 'User Management',
      breadcrumb: [
        {
          text: 'User Management',
          disabled: true
        },
        {
          text: 'User',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/user-management/role',
    name: 'user-management-role',
    component: () => import('../../views/user_management/role'),
    meta: {
      title: 'Role Management',
      activeMenu: 'Role Management',
      breadcrumb: [
        {
          text: 'User Management',
          disabled: true
        },
        {
          text: 'Role',
          disabled: true
        }
      ]
    }
  },
  // {
  //   path: '/user-management/role-detail',
  //   name: 'user-management-role-detail',
  //   component: () => import('../../views/user_management/role_detail'),
  //   meta: {
  //     title: 'Role Management',
  //     activeMenu: 'Role Management',
  //     breadcrumb: [
  //       {
  //         text: 'User Management',
  //         disabled: true
  //       },
  //       {
  //         text: 'Role',
  //         disabled: true
  //       },
  //       {
  //         text: 'Role Detail',
  //         disabled: true
  //       }
  //     ]
  //   }
  // },
  {
    path: '/user-management/riwayat-transaksi',
    name: 'user-management-riwayat-transaksi',
    component: () => import('../../views/user_management/riwayat_transaksi'),
    meta: {
      title: 'Riwayat Transaksi',
      activeMenu: 'Role Management',
      breadcrumb: [
        {
          text: 'User Management',
          disabled: true
        },
        {
          text: 'Riwayat Transaksi',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/user-management/access',
    name: 'user-management-access',
    component: () => import('../../views/user_management/access'),
    meta: {
      title: 'Access',
      activeMenu: 'Access',
      auth: true,
      breadcrumb: [
        {
          text: 'User Management',
          disabled: true
        },
        {
          text: 'Access',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/user-management/access/edit_access',
    name: 'user-management-access-edit_access',
    auth: true,
    component: () => import('../../views/user_management/edit_access'),
    meta: {
      title: 'Edit Access',
      activeMenu: 'Edit Access',
      breadcrumb: [
        {
          text: 'User Management',
          disabled: true
        },
        {
          text: 'Access',
          disabled: true
        },
        {
          text: 'Edit Access',
          disabled: true
        }
      ]
    }
  }
]
